// ข้อมูลสินค้าจากคลัสเตอร์ - Cluster Products Data
// Cluster SIE วันที่ 10 มกราคม 2569

// ชุดสินค้าทั้งหมด (Product Sets) — แต่ละ set มี banner ของตัวเอง
export const productSets = [
  {
    id: 'set1',
    label: 'Set 1 — C1 - C5',
    banner: {
      title: 'Cluster SIE',
      date: '10 มกราคม 2569',
      description: 'สนใจสินค้า แจ้ง รหัสสินค้า และ จำนวน ให้น้องแอดมิน ในไลน์ได้เลยค่ะ',
      image: 'https://iili.io/qFRBgxp.png',
      lineUrl: '#',
    },
    products: [
      {
        id: 'C1',
        code: 'C 1',
        name: 'น้ำนมข้าวกล้องหอมมะลิผสมมะระขี้นก',
        shortName: 'น้ำนมข้าวกล้อง Plant-based Milk',
        description: 'ผลิตภัณฑ์น้ำนมข้าวกล้องหอมมะลิผสมมะระขี้นก plant-based milk น้ำนมทางเลือกที่ผสมผสานคุณประโยชน์จากข้าวหอมมะลิระยะเขียวหยกที่อุดมด้วยโคลีน และโอเมก้า 3, 6, 9 ที่ช่วยการทำงานของระบบประสาทและสมอง',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/c1-rice-milk.jpg',
        imageAlt: 'น้ำนมข้าวกล้องหอมมะลิผสมมะระขี้นก C1',
        price: 49,
        unit: 'ขวด',
        cluster: 'คลัสเตอร์เกษตร',
        highlights: ['Plant-based', 'โอเมก้า 3,6,9', 'โคลีน'],
        badge: null,
      },
      {
        id: 'C2',
        code: 'C 2',
        name: 'ข้าวเกรียบปลาทอดกรอบรสดั้งเดิม',
        shortName: 'ข้าวเกรียบปลานัสรีน กรือโป๊ะ',
        description: 'ข้าวเกรียบปลานัสรีน (กรือโป๊ะ) สูตรลังกาสุกะ จังหวัดปัตตานี เป็นสูตรลับเฉพาะที่ถ่ายทอดมาจากภูมิปัญญาท้องถิ่น คัดสรรวัตถุดิบที่มีคุณภาพ ปลอดภัยต่อสุขภาพ ส่งต่อรสชาติกันยาวนานกว่า 100 ปี มีคุณค่าทางโภชนาการสูง อุดมไปด้วยโปรตีนและแคลเซียม ใส่ใจต่อสุขภาพ, ไขมันต่ำ',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/c2-fish-crisp-original.jpg',
        imageAlt: 'ข้าวเกรียบปลาทอดกรอบรสดั้งเดิม C2',
        price: 39,
        unit: 'ห่อ',
        cluster: 'คลัสเตอร์ประมง',
        highlights: ['สูตร 100 ปี', 'โปรตีนสูง', 'ไขมันต่ำ'],
        badge: null,
      },
      {
        id: 'C3',
        code: 'C 3',
        name: 'น้ำนมข้าวทับทิมชุมแพผสมมะระขี้นก',
        shortName: 'น้ำนมข้าวทับทิมชุมแพ Plant-based Milk',
        description: 'ผลิตภัณฑ์น้ำนมข้าวผสมมะระขี้นก plant-based milk น้ำนมทางเลือกที่ผสมผสานคุณประโยชน์จากข้าวทับทิมชุมแพที่มีดัชนีน้ำตาลต่ำ เข้ากับสารสกัดจากมะระขี้นก ที่มีสรรพคุณช่วยลดระดับน้ำตาลในเลือด ต้านการอักเสบ',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/c3-rice-milk-ruby.jpg',
        imageAlt: 'น้ำนมข้าวทับทิมชุมแพผสมมะระขี้นก C3',
        price: 49,
        unit: 'ขวด',
        cluster: 'คลัสเตอร์เกษตร',
        highlights: ['Plant-based', 'น้ำตาลต่ำ', 'ต้านอักเสบ'],
        badge: null,
      },
      {
        id: 'C4',
        code: 'C 4',
        name: 'ปลาแผ่นอบกรอบรสสไปซี่',
        shortName: 'ปลาแผ่นอบกรอบ ตรานัสรีน',
        description: 'ปลาแผ่นอบกรอบตรานัสรีน รสฮอตแอนด์สไปซี่ ไร้น้ำมัน ผ่านกระบวนการอบจนกรอบ มีกลิ่นหอมของปลา เผ็ดจัดจ้าน หอมอร่อย ผลิตจากเนื้อปลาทรายถึง 75% อร่อยเข้มข้น ได้รสเนื้อปลาแท้ๆ มีคุณค่าทางโภชนาการสูง อุดมไปด้วยโปรตีน',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/c4-fish-crisp-spicy.jpg',
        imageAlt: 'ปลาแผ่นอบกรอบรสสไปซี่ C4',
        price: 30,
        unit: 'ห่อ',
        cluster: 'คลัสเตอร์ประมง',
        highlights: ['ไร้น้ำมัน', 'เนื้อปลาทราย 75%', 'โปรตีนสูง'],
        badge: null,
      },
      {
        id: 'C5',
        code: 'C 5',
        name: 'ปลาแผ่นอบกรอบรสโนริสาหร่าย',
        shortName: 'ปลาแผ่นอบกรอบ BAKED CRISPY FISH',
        description: 'ปลาแผ่นอบกรอบ (BAKED CRISPY FISH) รสโนริสาหร่าย ผ่านกระบวนการอบจนกรอบ',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/c5-fish-crisp-nori.jpg',
        imageAlt: 'ปลาแผ่นอบกรอบรสโนริสาหร่าย C5',
        price: 30,
        unit: 'ห่อ',
        cluster: 'คลัสเตอร์ประมง',
        highlights: ['อบกรอบ', 'รสโนริสาหร่าย'],
        badge: null,
      },
    ],
  },
  {
    id: 'set2',
    label: 'Set 2 — C6 - C10',
    banner: {
      title: 'Cluster SIE',
      date: '10 มกราคม 2569',
      description: 'สนใจสินค้า แจ้ง รหัสสินค้า และ จำนวน ให้น้องแอดมิน ในไลน์ได้เลยค่ะ',
      image: 'https://iili.io/qFRB8Ov.png',
      lineUrl: '#',
    },
    products: [
      {
        id: 'C6',
        code: 'C 6',
        name: 'ปลาแผ่นอบกรอบรสปลาหมึก',
        shortName: 'ปลาแผ่นอบกรอบ ตรานัสรีน',
        description: 'ปลาแผ่นอบกรอบตรานัสรีน รสปลาหมึก ไร้น้ำมัน ผ่านกระบวนการอบจนกรอบ มีกลิ่นหอมของปลา เข้มข้นกลมกล่อมด้วยรสปลาหมึก ผลิตจากเนื้อปลาทรายถึง 75% อร่อยเข้มข้น ได้รสเนื้อปลาแท้ๆ',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/c6-fish-crisp-squid.jpg',
        imageAlt: 'ปลาแผ่นอบกรอบรสปลาหมึก C6',
        price: 30,
        unit: 'ห่อ',
        cluster: 'คลัสเตอร์ประมง',
        highlights: ['ไร้น้ำมัน', 'เนื้อปลาทราย 75%', 'อบกรอบ'],
        badge: null,
      },
      {
        id: 'C7',
        code: 'C 7',
        name: 'ข้าวเกรียบปลาทอดกรอบรสสาหร่าย',
        shortName: 'ข้าวเกรียบปลานัสรีน กรือโป๊ะ',
        description: 'ข้าวเกรียบปลานัสรีน (กรือโป๊ะ) สูตรลังกาสุกะ จังหวัดปัตตานี เป็นสูตรลับเฉพาะที่ถ่ายทอดมาจากภูมิปัญญาท้องถิ่น คัดสรรวัตถุดิบที่มีคุณภาพ ปลอดภัยต่อสุขภาพ ส่งต่อรสชาติกันยาวนานกว่า 100 ปี มีคุณค่าทางโภชนาการสูง อุดมไปด้วยโปรตีนและแคลเซียม ใส่ใจต่อสุขภาพ, ไขมันต่ำ',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/c7-fish-crisp-seaweed.jpg',
        imageAlt: 'ข้าวเกรียบปลาทอดกรอบรสสาหร่าย C7',
        price: 39,
        unit: 'ห่อ',
        cluster: 'คลัสเตอร์ประมง',
        highlights: ['สูตร 100 ปี', 'โปรตีนสูง', 'ไขมันต่ำ'],
        badge: null,
      },
      {
        id: 'C8',
        code: 'C 8',
        name: 'ข้าวเกรียบปลาทอดกรอบ รสสไปซี่',
        shortName: 'Fish Crisp รสสไปซี่',
        description: 'ข้าวเกรียบปลาทอดกรอบ (Fish Crisp) รสสไปซี่ มีโปรตีน มีแคลเซียม มีโอเมก้า 3 ผลิตจากเนื้อปลาแท้ 100%',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/c8-fish-crisp-spicy.jpg',
        imageAlt: 'ข้าวเกรียบปลาทอดกรอบ รสสไปซี่ C8',
        price: 39,
        unit: 'ห่อ',
        cluster: 'คลัสเตอร์ประมง',
        highlights: ['เนื้อปลาแท้ 100%', 'โอเมก้า 3', 'แคลเซียมสูง'],
        badge: null,
      },
      {
        id: 'C9',
        code: 'C 9',
        name: 'ข้าวเกรียบปลาทอดกรอบรสกระเทียม',
        shortName: 'ข้าวเกรียบปลานัสรีน รสกระเทียม',
        description: 'ข้าวเกรียบปลานัสรีน (กรือโป๊ะ) สูตรลังกาสุกะ จังหวัดปัตตานี เป็นสูตรลับเฉพาะที่ถ่ายทอดมาจากภูมิปัญญาท้องถิ่น คัดสรรวัตถุดิบที่มีคุณภาพ ปลอดภัยต่อสุขภาพ ส่งต่อรสชาติกันยาวนานกว่า 100 ปี มีคุณค่าทางโภชนาการสูง อุดมไปด้วยโปรตีนและแคลเซียม ใส่ใจต่อสุขภาพ, ไขมันต่ำ',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/c9-fish-crisp-garlic.jpg',
        imageAlt: 'ข้าวเกรียบปลาทอดกรอบรสกระเทียม C9',
        price: 39,
        unit: 'ห่อ',
        cluster: 'คลัสเตอร์ประมง',
        highlights: ['สูตร 100 ปี', 'โปรตีนสูง', 'ไขมันต่ำ'],
        badge: null,
      },
      {
        id: 'C10',
        code: 'C 10',
        name: 'ข้าวเกรียบปลาแผ่นดิบ',
        shortName: 'ข้าวเกรียบปลาแผ่นดิบ',
        description: 'มีความเข้มข้นของเนื้อปลาโอมากถึง 70% มีกรดไขมันโอเมก้า 3 เป็นจำนวนมาก นอกจากนี้ยังอุดมไปด้วยโปรตีน ไอโอดีน วิตามินบี ธาตุซิลิเนียม ไม่มีไขมัน เหมาะสำหรับผู้ที่ลดความอ้วน',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/c10-raw-fish-crisp.jpg',
        imageAlt: 'ข้าวเกรียบปลาแผ่นดิบ C10',
        price: 150,
        unit: 'ห่อ',
        cluster: 'คลัสเตอร์ประมง',
        highlights: ['เนื้อปลาโอ 70%', 'โอเมก้า 3', 'ไม่มีไขมัน'],
        badge: 'พรีเมียม',
      },
    ],
  },
  {
    id: 'set3',
    label: 'Set 3 — B6 - B10',
    banner: {
      title: 'Cluster SIE',
      date: '10 มกราคม 2569',
      description: 'สนใจสินค้า แจ้ง รหัสสินค้า และ จำนวน ให้น้องแอดมิน ในไลน์ได้เลยค่ะ',
      image: 'https://iili.io/qFRBPft.png',
      lineUrl: '#',
    },
    products: [
      {
        id: 'B6',
        code: 'B 6',
        name: 'สมุนไพรกาแฟดำ (Herbal Harmony Coffee and Bitter Melon)',
        shortName: 'สมุนไพรกาแฟดำ',
        description: 'ควบคุมระดับน้ำตาลในเลือด ควบคุมความดัน ช่วยดีท็อกซ์ (Detox) ตับและลำไส้ อุดมไปด้วยสารต้านอนุมูลอิสระ ช่วยปกป้องเซลล์จากการถูกทำลาย',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/b6-herbal-coffee.jpg',
        imageAlt: 'สมุนไพรกาแฟดำ B6',
        price: 350,
        unit: 'กล่อง',
        cluster: 'คลัสเตอร์เกษตร',
        highlights: ['ควบคุมน้ำตาล', 'Detox', 'ต้านอนุมูลอิสระ'],
        badge: null,
      },
      {
        id: 'B7',
        code: 'B 7',
        name: 'เครื่องดื่มน้ำนมข้าวหอมมะลิ อินทรีย์ เสริมโปรตีน ชนิดผง',
        shortName: 'Rice Milk Powder',
        description: 'มีโปรตีนสูงและไขมันต่ำ ทำให้รู้สึกอิ่มนานและช่วยควบคุมน้ำหนัก มีแคลเซียมสูง ช่วยในการลดและควบคุมระดับน้ำตาลในเลือด ลดความเสี่ยงในการเป็นโรคเบาหวาน',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/b7-rice-milk-powder.jpg',
        imageAlt: 'เครื่องดื่มน้ำนมข้าวหอมมะลิ B7',
        price: 350,
        unit: 'กล่อง',
        cluster: 'คลัสเตอร์เกษตร',
        highlights: ['โปรตีนสูง', 'แคลเซียมสูง', 'ไขมันต่ำ'],
        badge: null,
      },
      {
        id: 'B8',
        code: 'B 8',
        name: 'กาแฟพร้อมชงดื่มผสมอาหารเพื่อสุขภาพ (Healthy Energy)',
        shortName: 'Coffee Dietary Fiber',
        description: 'ผลิตจากฟักทอง กล้วยหอม ครีมเทียมจากข้าวหอมมะลิ มะระขี้นก ช่วยลดน้ำตาลในเลือดและควบคุมระดับอินซูลิน เสริมสร้างการขับสารพิษ (Detox) จากตับและลำไส้ ต้านอนุมูลอิสระ ชะลอวัย บำรุงผิวจากภายใน',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/b8-healthy-coffee.jpg',
        imageAlt: 'กาแฟพร้อมชงดื่ม Healthy Energy B8',
        price: 350,
        unit: 'กล่อง',
        cluster: 'คลัสเตอร์เกษตร',
        highlights: ['Detox', 'ลดน้ำตาล', 'ชะลอวัย'],
        badge: null,
      },
      {
        id: 'B9',
        code: 'B 9',
        name: 'โกโก้แท้เกรดพรีเมียม จากปัตตานี (500 กรัม)',
        shortName: 'Kholotanyong Cocoa 500g',
        description: 'Kholotanyong Cocoa โกโก้แท้ 100% เกรดพรีเมียม จากแบรนด์ท้องถิ่นจังหวัดปัตตานี ผลิตจากเมล็ดโกโก้คุณภาพสูง ผ่านกระบวนการผลิตมาตรฐาน "อย." และ "ฮาลาล"',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/b9-cocoa-500g.jpg',
        imageAlt: 'โกโก้แท้เกรดพรีเมียม 500g B9',
        price: 689,
        unit: 'กล่อง',
        cluster: 'คลัสเตอร์เกษตร',
        highlights: ['โกโก้แท้ 100%', 'อย.', 'ฮาลาล'],
        badge: 'พรีเมียม',
      },
      {
        id: 'B10',
        code: 'B 10',
        name: 'โกโก้แท้เกรดพรีเมียม จากปัตตานี (200 กรัม)',
        shortName: 'Kholotanyong Cocoa 200g',
        description: 'Kholotanyong Cocoa โกโก้แท้ 100% เกรดพรีเมียม จากแบรนด์ท้องถิ่นจังหวัดปัตตานี ผลิตจากเมล็ดโกโก้คุณภาพสูง ผ่านกระบวนการผลิตมาตรฐาน "อย." และ "ฮาลาล"',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/b10-cocoa-200g.jpg',
        imageAlt: 'โกโก้แท้เกรดพรีเมียม 200g B10',
        price: 359,
        unit: 'กล่อง',
        cluster: 'คลัสเตอร์เกษตร',
        highlights: ['โกโก้แท้ 100%', 'อย.', 'ฮาลาล'],
        badge: 'พรีเมียม',
      },
    ],
  },
  {
    id: 'set4',
    label: 'Set 4 — B1 - B5',
    banner: {
      title: 'Cluster SIE',
      date: '10 มกราคม 2569',
      description: 'สนใจสินค้า แจ้ง รหัสสินค้า และ จำนวน ให้น้องแอดมิน ในไลน์ได้เลยค่ะ',
      image: 'https://iili.io/qFRBSbR.png',
      lineUrl: '#',
    },
    products: [
      {
        id: 'B1',
        code: 'B 1',
        name: 'ชาสมุนไพรต้นอ่อนข้าวหอมมะลิผสมมะระขี้นก',
        shortName: 'Jasmine Rice Sprout Herbal Tea',
        description: 'ช่วยลดน้ำตาลในเลือดและควบคุมระดับอินซูลิน เสริมสร้างการขับสารพิษ (Detox) จากตับและลำไส้ ต้านอนุมูลอิสระ ลดอาการบวมน้ำ บวมหน้า',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/b1-herbal-tea.jpg',
        imageAlt: 'ชาสมุนไพรต้นอ่อนข้าวหอมมะลิ B1',
        price: 350,
        unit: 'กล่อง',
        cluster: 'คลัสเตอร์เกษตร',
        highlights: ['ลดน้ำตาล', 'Detox', 'ต้านอนุมูลอิสระ'],
        badge: null,
      },
      {
        id: 'B2',
        code: 'B 2',
        name: 'เครื่องดื่มใบข้าวหอมมะลิไทยสุวรรณ',
        shortName: 'ชาใบข้าวหอมมะลิ ไทยสุวรรณ',
        description: '5 ประโยชน์ "ชาใบข้าวหอมมะลิไทยสุวรรณ" มีสารต้านอนุมูลอิสระ ช่วยป้องกันโรคเส้นเลือดในสมองตีบ ลดระดับคอเลสเตอรอลในร่างกาย ลดภาวะอาการอัลไซเมอร์ ชะลอกระบวนการแก่ชรา',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/b2-rice-leaf-drink.jpg',
        imageAlt: 'เครื่องดื่มใบข้าวหอมมะลิ B2',
        price: 150,
        unit: 'กล่อง',
        cluster: 'คลัสเตอร์เกษตร',
        highlights: ['ต้านอนุมูลอิสระ', 'ลดคอเลสเตอรอล', 'ชะลอวัย'],
        badge: null,
      },
      {
        id: 'B3',
        code: 'B 3',
        name: 'ชาสมุนไพร 3 พลัง : ต้นอ่อนข้าวหอมมะลิ กาแฟดำ มะระขี้นก',
        shortName: 'ชาสมุนไพร 3 พลัง ไทยสุวรรณ',
        description: 'ช่วยลดน้ำตาลในเลือดและควบคุมระดับอินซูลิน เสริมสร้างการขับสารพิษ (Detox) จากตับและลำไส้ ต้านอนุมูลอิสระ ลดความเสี่ยงโรคเบาหวาน ช่วยในการออกกำลังกายลดอาการบวมน้ำ',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/b3-herbal-tea-3power.jpg',
        imageAlt: 'ชาสมุนไพร 3 พลัง B3',
        price: 350,
        unit: 'กล่อง',
        cluster: 'คลัสเตอร์เกษตร',
        highlights: ['Detox', 'ลดเบาหวาน', 'ลดบวมน้ำ'],
        badge: null,
      },
      {
        id: 'B4',
        code: 'B 4',
        name: 'ชาเขียวต้นอ่อนข้าวหอมมะลิ อินทรีย์ ชนิดผง',
        shortName: 'Herbal Tea Rice Baby Leaves & Matcha',
        description: 'โปรตีน ช่วยป้องกันการสูญเสียมวล ใยอาหาร ช่วยให้ระบบขับถ่ายทำงานดี เบต้าแคโรทีน ปกป้องผิวจากรังสียูวี วิตามินเอ บำรุงสายตา เหล็กช่วยป้องกันการอ่อนเพลียเสริมสร้างภูมิต้านทาน',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/b4-green-tea-rice.jpg',
        imageAlt: 'ชาเขียวต้นอ่อนข้าวหอมมะลิ B4',
        price: 350,
        unit: 'กล่อง',
        cluster: 'คลัสเตอร์เกษตร',
        highlights: ['อินทรีย์', 'เบต้าแคโรทีน', 'วิตามินเอ'],
        badge: null,
      },
      {
        id: 'B5',
        code: 'B 5',
        name: 'ธัญฉะ มัทฉะ จากต้นอ่อนข้าวหอมมะลิ อินทรีย์ ชนิดผง',
        shortName: 'ธัญฉะ มัทฉะ อินทรีย์',
        description: 'โปรตีน ช่วยป้องกันการสูญเสียมวล ใยอาหาร ช่วยให้ระบบขับถ่ายทำงานดี ลดระดับคอเลสเตอรอลได้ เบต้าแคโรทีน ปกป้องผิวจากรังสียูวี วิตามินเอ บำรุงสายตา เหล็กช่วยป้องกันการอ่อนเพลียเสริมสร้างภูมิต้านทาน',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/b5-matcha-rice.jpg',
        imageAlt: 'ธัญฉะ มัทฉะ B5',
        price: 250,
        unit: 'กล่อง',
        cluster: 'คลัสเตอร์เกษตร',
        highlights: ['อินทรีย์', 'ลดคอเลสเตอรอล', 'บำรุงสายตา'],
        badge: null,
      },
    ],
  },
  {
    id: 'set5',
    label: 'Set 5 — A6 - A10',
    banner: {
      title: 'Cluster SIE',
      date: '10 มกราคม 2569',
      description: 'สนใจสินค้า แจ้ง รหัสสินค้า และ จำนวน ให้น้องแอดมิน ในไลน์ได้เลยค่ะ',
      image: 'https://iili.io/qFRBrWN.png',
      lineUrl: '#',
    },
    products: [
      {
        id: 'A6',
        code: 'A 6',
        name: 'ผงมะระสเปรย์ดราย ไทยสุวรรณ',
        shortName: 'ผงมะระสเปรย์ดราย',
        description: 'ประโยชน์มะระขี้นก ลดความดันโลหิตสูง ช่วยบำบัดและรักษาโรคเบาหวาน ลดระดับน้ำตาลในเลือด ช่วยต่อต้านและป้องกันการเกิดโรคมะเร็ง',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/a6-bitter-melon-powder.jpg',
        imageAlt: 'ผงมะระสเปรย์ดราย A6',
        price: 350,
        unit: 'กล่อง',
        cluster: 'คลัสเตอร์เกษตร',
        highlights: ['ลดความดัน', 'ลดน้ำตาล', 'ต้านมะเร็ง'],
        badge: null,
      },
      {
        id: 'A7',
        code: 'A 7',
        name: 'ผงถั่วเขียวสเปรย์ดราย ไทยสุวรรณ',
        shortName: 'ผงถั่วเขียวสเปรย์ดราย',
        description: 'มีโพแทสเซียมช่วยเสริมสร้างกล้ามเนื้อในร่างกายให้แข็งแรง วิตามินบี 1 ป้องกันโรคเหน็บชา วิตามินบี 2 ป้องกันโรคปากนกกระจอก ช่วยควบคุมระดับไขมันในเลือด มีธาตุเหล็กสำหรับการสร้างเม็ดเลือดแดงในร่างกาย',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/a7-mung-bean-powder.jpg',
        imageAlt: 'ผงถั่วเขียวสเปรย์ดราย A7',
        price: 350,
        unit: 'กล่อง',
        cluster: 'คลัสเตอร์เกษตร',
        highlights: ['โพแทสเซียม', 'วิตามินบี', 'ธาตุเหล็ก'],
        badge: null,
      },
      {
        id: 'A8',
        code: 'A 8',
        name: 'ผงถั่วแดงสเปรย์ดราย ไทยสุวรรณ',
        shortName: 'ผงถั่วแดงสเปรย์ดราย',
        description: 'ประโยชน์ของถั่วแดง บำรุงสมอง บำรุงประสาท มีแคลเซี่ยม ช่วยบำรุงกระดูกและป้องกันโรคกระดูกพรุน อุดมไปด้วยวิตามินบี',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/a8-red-bean-powder.jpg',
        imageAlt: 'ผงถั่วแดงสเปรย์ดราย A8',
        price: 350,
        unit: 'กล่อง',
        cluster: 'คลัสเตอร์เกษตร',
        highlights: ['บำรุงสมอง', 'แคลเซียม', 'วิตามินบี'],
        badge: null,
      },
      {
        id: 'A9',
        code: 'A 9',
        name: 'ผงถั่วเหลืองสเปรย์ดราย ไทยสุวรรณ',
        shortName: 'ผงถั่วเหลืองสเปรย์ดราย',
        description: 'คุณประโยชน์จากสารสกัดถั่วเหลืองที่ดีต่อผิว ให้ความชุ่มชื้น ความยืดหยุ่นของผิวดีขึ้น แหล่งของวิตามินจากธรรมชาติ ช่วยให้ผิวกระจ่างใสและต่อสู้กับริ้วรอย',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/a9-soy-bean-powder.jpg',
        imageAlt: 'ผงถั่วเหลืองสเปรย์ดราย A9',
        price: 350,
        unit: 'กล่อง',
        cluster: 'คลัสเตอร์เกษตร',
        highlights: ['บำรุงผิว', 'ชุ่มชื้น', 'วิตามินธรรมชาติ'],
        badge: null,
      },
      {
        id: 'A10',
        code: 'A 10',
        name: 'ชาใบข้าวหอมมะลิไทยสุวรรณ (ชนิดผง)',
        shortName: 'ชาใบข้าวหอมมะลิ ชนิดผง',
        description: '5 ประโยชน์ "ชาใบข้าวหอมมะลิไทยสุวรรณ" มีสารต้านอนุมูลอิสระ ช่วยป้องกันโรคเส้นเลือดในสมองตีบ ลดระดับคอเลสเตอรอลในร่างกาย ลดภาวะอาการอัลไซเมอร์ ชะลอกระบวนการแก่ชรา',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/a10-rice-tea-powder.jpg',
        imageAlt: 'ชาใบข้าวหอมมะลิ ชนิดผง A10',
        price: 350,
        unit: 'กล่อง',
        cluster: 'คลัสเตอร์เกษตร',
        highlights: ['ต้านอนุมูลอิสระ', 'ลดคอเลสเตอรอล', 'ชะลอวัย'],
        badge: null,
      },
    ],
  },
  {
    id: 'set6',
    label: 'Set 6 — A1 - A5',
    banner: {
      title: 'Cluster SIE',
      date: '11 มกราคม 2569',
      description: 'สนใจสินค้า แจ้ง รหัสสินค้า และ จำนวน ให้น้องแอดมิน ในไลน์ได้เลยค่ะ',
      image: 'https://iili.io/qFRBv5J.png',
      lineUrl: '#',
    },
    products: [
      {
        id: 'A1',
        code: 'A 1',
        name: 'ผงข้าวโพดหวาน ไทยสุวรรณ',
        shortName: 'ผงข้าวโพดหวาน',
        description: 'ประโยชน์ข้าวโพด อุดมไปด้วยวิตามิน A B และแร่ธาตุ มีไฟเบอร์สูง แหล่งต้านอนุมูลอิสระ',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/a1-corn-powder.jpg',
        imageAlt: 'ผงข้าวโพดหวาน A1',
        price: 350,
        unit: 'กล่อง',
        cluster: 'คลัสเตอร์เกษตร',
        highlights: ['วิตามิน A,B', 'ไฟเบอร์สูง', 'ต้านอนุมูลอิสระ'],
        badge: null,
      },
      {
        id: 'A2',
        code: 'A 2',
        name: 'ผงกล้วยหอมทอง ไทยสุวรรณ',
        shortName: 'ผงกล้วยหอมทอง',
        description: 'ประโยชน์กล้วยหอม ลดแผลในกระเพาะ เพิ่มพลังงาน คลายเครียด แก้ท้องผูก ลดตะคริว บำรุงประสาท ลดความดันโลหิต',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/a2-banana-powder.jpg',
        imageAlt: 'ผงกล้วยหอมทอง A2',
        price: 350,
        unit: 'กล่อง',
        cluster: 'คลัสเตอร์เกษตร',
        highlights: ['เพิ่มพลังงาน', 'บำรุงประสาท', 'ลดความดัน'],
        badge: null,
      },
      {
        id: 'A3',
        code: 'A 3',
        name: 'ผงฟักทอง ไทยสุวรรณ',
        shortName: 'ผงฟักทอง',
        description: 'ประโยชน์ฟักทอง สารต้านอนุมูลอิสระลดความเสี่ยงการเป็นมะเร็ง ป้องกันโรคเบาหวาน ป้องกันโรคหลอดเลือดและหัวใจ ช่วยให้ระบบขับถ่ายทำงานอย่างเป็นปกติ',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/a3-pumpkin-powder.jpg',
        imageAlt: 'ผงฟักทอง A3',
        price: 350,
        unit: 'กล่อง',
        cluster: 'คลัสเตอร์เกษตร',
        highlights: ['ต้านมะเร็ง', 'ป้องกันเบาหวาน', 'บำรุงหัวใจ'],
        badge: null,
      },
      {
        id: 'A4',
        code: 'A 4',
        name: 'ผงข้าวโพดทับทิมสยามสำเร็จรูป ไทยสุวรรณ',
        shortName: 'ผงข้าวโพดทับทิมสยาม',
        description: 'ป้องกันโรคเบาหวานและความดันโลหิตสูง ชะลอความแก่และบำรุงผิวพรรณ ป้องกันโรคหัวใจ ป้องกันโรคมะเร็ง ลดการสะสมคอเลสเตอรอล บำรุงสายตา อุดมไปด้วยสารแอนโทไซยานิน ต้านอนุมูลอิสระ',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/a4-ruby-corn-powder.jpg',
        imageAlt: 'ผงข้าวโพดทับทิมสยาม A4',
        price: 350,
        unit: 'กล่อง',
        cluster: 'คลัสเตอร์เกษตร',
        highlights: ['แอนโทไซยานิน', 'บำรุงสายตา', 'ชะลอวัย'],
        badge: null,
      },
      {
        id: 'A5',
        code: 'A 5',
        name: 'ผลิตภัณฑ์ครีมผงจากข้าวหอมมะลิ ไทยสุวรรณ',
        shortName: 'ครีมผงข้าวหอมมะลิ',
        description: 'อาหารเพื่อสุขภาพไขมันต่ำ (ต่ำกว่าท้องตลาด 30%) ปราศจากไขมันทรานส์ มีกรดไขมันโอเมก้า 3,6,9 ไม่มีคอเลสเตอรอล น้ำตาลต่ำ มีโปรตีน และสารต้านอนุมูลอิสระ',
        image: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/products/a5-rice-cream-powder.jpg',
        imageAlt: 'ครีมผงข้าวหอมมะลิ A5',
        price: 350,
        unit: 'กล่อง',
        cluster: 'คลัสเตอร์เกษตร',
        highlights: ['ไขมันต่ำ', 'โอเมก้า 3,6,9', 'ไม่มีคอเลสเตอรอล'],
        badge: null,
      },
    ],
  },
]
export const productsList = productSets.flatMap(set => set.products)

// ฟอร์แมตราคา
export const formatPrice = (price) => {
  return `฿${price.toLocaleString()}`
}

export default {
  productSets,
  productsList,
  formatPrice,
}
